import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { extend, wpComponents, vuetifyComponents } from '../components';
import ru from 'vuetify/src/locale/ru';
import SibNewArenaSectors from './SibArenaSectors/sib-arena-sectors';
import { Resize, Scroll } from 'vuetify/lib/directives';

wpComponents['wp-arena-sectors'] = SibNewArenaSectors;

const allComponents = extend(wpComponents, vuetifyComponents);

Vue.use(Vuetify, { components: allComponents, directives: { Resize, Scroll } });

export default new Vuetify({
    lang: {
        locales: { ru },
        current: 'ru'
    },   
});